import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { StringHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/StringHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { ApplicationInformationService } from "@seriously-rad/seriouslyrad-framework-core/RadWindow";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { PageManager } from "@seriously-rad/seriouslyrad-framework-core/Ui/PageManager";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandEntityFileOpenPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandEntityFileOpenProperties = {
    [name in keyof EntityCommandEntityFileOpenPropertyValues]: Property<EntityCommandEntityFileOpenPropertyValues[name]>
};

export interface IEntityCommandEntityFileOpen extends IEntityCommand, EntityCommandEntityFileOpenProperties
{
}

export class EntityCommandEntityFileOpen extends EntityCommand implements IEntityCommandEntityFileOpen
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandEntityFileOpen";
    public static override className = "EntityCommandEntityFileOpen";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandEntityFileOpenPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Open",
                entityName: "EntityFile",
                isDefault: true,
                key: "OPEN",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandEntityFileOpenPropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        ServiceManager.getRequired(WebApiClientService)
                            .createApiMethodRequest("DataService", "CallDataService", { id: "fced19e2-5bb5-49df-81b2-5a7488859416", operation: "GetIsViewerSupported", data: ObjectHelper.toJson({ entityFileId: recordId }) })
                            .executeAsync()
                            .then(data =>
                            {
                                if (data)
                                {
                                    PageManager.instance?.navigateAsync(
                                        StringHelper.format(
                                            "{0}modules/files/entityfileviewer/{1}/",
                                            ServiceManager.getRequired(ApplicationInformationService).virtualDirectory,
                                            recordId
                                        )
                                    );

                                    return;
                                }

                                window.open(
                                    StringHelper.format(
                                        "{0}api/entityfile/getentityfile/{1}/",
                                        ServiceManager.getRequired(ApplicationInformationService).serverVirtualDirectory,
                                        recordId
                                    )
                                );
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

